/**
 * Leaderboard service — fetches top 10 players from the backend.
 * Uses the centralised auth token from authService.
 */

import { getAccessToken } from './authService';

const API_BASE = '/api';

export interface LeaderboardEntry {
  rank: number;
  nickname: string;
  avatar: string;
  totalWins: number;
}

export async function fetchLeaderboard(): Promise<LeaderboardEntry[]> {
  const token = getAccessToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}/leaderboard`, {
    method: 'GET',
    headers,
    credentials: 'include',
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Failed to fetch leaderboard' }));
    throw new Error(err.message || 'Failed to fetch leaderboard');
  }

  // Backend returns { leaderboard: [...] }; unwrap to the array
  const data = await res.json();
  return Array.isArray(data) ? data : (data.leaderboard ?? []);
}
